import { Button, Grid, Stack, Typography } from "@mui/material";
import BackgroundImg from '../../../assets/background/img1.jpg'
import useResponsive from "../../../hooks/minimal/useResponsive.jsx";
import Iconify from "../../../components/minimal/iconify/index.jsx";
import { SeoIllustration } from "../../../assets/illustrations/index.jsx";
import { CardFeature } from "./CardFeature.jsx";
import HomeDarkMode from "../minimal/HomeDarkMode.jsx";
import HomeColorPresets from "../minimal/HomeColorPresets.jsx";
import { MotionViewport, varFade, varSlide } from "../../../components/minimal/animate/index.jsx";
import { m } from 'framer-motion';
import Footer from "../../../layouts/main/Footer.jsx";
import AboutTestimonials from "./AboutTestimonials.jsx";
import NimiHero from "./NimiHero.jsx";
import { InlineWidget } from "react-calendly";
import ActivitySection from "./ActivitySection";
import TicketScannerSection from "./TicketScannerSection";
import { Fab } from "@mui/material";
import CustomerClubSection from "./CustomerClubSection";
import BookDemo from "./BookDemo";
import WhatsappUs from "./WhatsappUs";

export const NimiLandingPage = () => {

    const isMobile = useResponsive('down', 'md');
    // encode the text to be sent to whatsapp

    return (
        <Stack>
            <WhatsappUs />
            <NimiHero />
            <div id="scroll-anchor" />
            <TicketScannerSection />
            <ActivitySection />
            <CustomerClubSection />
            <HomeColorPresets />
            <HomeDarkMode />


            {/*             <Stack
                sx={{
                    height: "70vh",
                    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(${BackgroundImg})`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    position: "relative"
                }}
            >
                <Stack
                    component={MotionViewport}
                    sx={{
                        width: isMobile ? "90%" : "55%",
                        position: "absolute",
                        top: "50%",
                        left: isMobile ? "50%" : "10%",
                        gap: 2,
                        transform: isMobile ? 'translate(-50%, -50%)' : 'translate(0, -50%)'
                    }}>
                    <m.div variants={varFade().inLeft}>
                        <Typography variant="h2" sx={{ color: '#fff' }}>
                            פלטפורמה לניהול אירועים והפקות בהתאמה אישית עבור בתי תרבות ומפיקי על

                        </Typography>
                    </m.div>
                    <m.div variants={varFade().inRight}>
                        <Typography variant="subtitle" sx={{ color: '#fff' }}>
                            מערכת גמישה ומגוונת למכירת כרטיסים אונליין וניהול מפיקים חיצוניים תחת הבראנד שלכם תוך גביית עמלה אוטומטית
                        </Typography>
                    </m.div>

                    <m.div variants={varFade().inUp}>
                        <Button variant="contained" size="large" sx={{ width: isMobile ? "100%": "auto" }}>
                            <a href="mailto:hagit@nimi.co.il" target="_blank" style={{ textDecoration: "none", color: "#fff" }} rel="noreferrer">לחצו כאן לקביעת דמו </a>
                        </Button>

                    </m.div>
                </Stack>

            </Stack> */}
            <Stack
                id="why-nimi"
                component={MotionViewport}
                direction={isMobile ? "column" : "row"}
                sx={{ justifyContent: "space-between", gap: 4, px: isMobile ? 1 : "10%" }}
            >

                <Stack
                    component={MotionViewport}
                    sx={{
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        width: isMobile ? "95%" : "60%",
                        mx: 'auto',
                        gap: 4,
                        mt: 16
                    }}>
                    <m.div variants={varFade().inUp}>
                        <Typography variant="BODY" color={"text.secondary"}>
                            עדיין מתלבטים
                        </Typography>
                        <Typography variant="h2">
                            למה כדאי לעבוד עם נימי?
                        </Typography>
                    </m.div>
                    <m.div variants={varFade().inUp}>
                        <SeoIllustration sx={{ width: isMobile ? "100%" : "400px" }} />
                    </m.div>

                </Stack>

            </Stack>

            <Stack component={MotionViewport}
                direction={{ sm: 'column', md: 'row' }}
                sx={{ width: '100%', mt: 8, mb: 16, justifyContent: 'center', gap: 5 }}>

                <Stack component={m.div} variants={varFade().inUp} sx={{ gap: 2, textAlign: "center", alignItems: "center" }}>
                    <Iconify width="40px" icon="ph:code-bold" color="primary.main" />
                    <Typography variant="h5">
                        פיתוח מותאם אישית
                    </Typography>
                    <Typography variant="subtitle2" sx={{ maxWidth: "300px" }}>
                        נימי שמה דגש על התאמה מדוייקת לצרכים שלכם בכדי להקל עליכם ביצירה וניהול אירועים
                    </Typography>
                </Stack>

                <Stack component={m.div} variants={varFade().inUp} sx={{ gap: 2, textAlign: "center", alignItems: "center" }}>
                    <Iconify width="40px" icon="la:store" color="primary.main" />
                    <Typography variant="h5">
                        העסק שלכם - הפלפטפורמה שלכם
                    </Typography>
                    <Typography variant="subtitle2" sx={{ maxWidth: "300px" }}>
                        נימי עובדת עם הדומיין והלוגו שלכם כדי לעזור לכם להעצים את המותג שלכם
                    </Typography>
                </Stack>

                <Stack component={m.div} variants={varFade().inUp} sx={{ gap: 2, textAlign: "center", alignItems: "center" }}>
                    <Iconify width="40px" icon="solar:hand-money-linear" color="primary.main" />
                    <Typography variant="h5">
                        מעכשיו אתם מקבלים עמלה
                    </Typography>
                    <Typography variant="subtitle2" sx={{ maxWidth: "300px" }}>
                        נימי מאפשרת להכניס מפיקים תחת המערכת שלכם עבור עמלה לבחירתכם
                    </Typography>
                </Stack>

                <Stack component={m.div} variants={varFade().inUp} sx={{ gap: 2, textAlign: "center", alignItems: "center" }}>
                    <Iconify width="40px" icon="mingcute:love-line" color="primary.main" />
                    <Typography variant="h5">
                        תנו לקהילה שלכם אהבה
                    </Typography>
                    <Typography variant="subtitle2" sx={{ maxWidth: "300px" }}>
                        נימי זוכרת את הלקוחות שלכם, ועוזרת לכם להביא לקוחות חוזרים ואפילו לנהל קהילה
                    </Typography>
                </Stack>
            </Stack>

            <AboutTestimonials />

            <MotionViewport>
                <Stack sx={{ textAlign: 'center', mt: 16 }}>
                    <m.div variants={varFade().inUp}>
                        <Typography variant="h2">
                            ויש לנימי עוד הרבה מה להציע
                        </Typography>
                    </m.div>
                </Stack>
            </MotionViewport>
            <Grid
                container
                sx={{ px: "5%", mt: 8, gap: 4, justifyContent: "center" }}
            >

                <CardFeature
                    iconName="material-symbols:event"
                    title="דפי אירוע דינמים"
                    subTitle="יצירת דף האירוע מעולם לא היה קל יותר! עם היכולות המתקדמות של נימי תוכלו בקלות לייצר דפי אירועים מעוצבים וממותגים ולהפיץ אותם ללא הגבלה"
                />

                <CardFeature
                    iconName="material-symbols:public"
                    title="אירועים פרטיים / ציבוריים"
                    subTitle="יצירת אירועים פרטיים וחסויים שרק לקוחות בעלי גישה יכולים לרכוש כרטיס"
                />

                <CardFeature
                    iconName="material-symbols:event-seat"
                    title="מקומות הושבה"
                    subTitle="בעזרת נימי ניתן גם לייצר אירועים עם הושבה במקומות מסומנים ולתכנן אצטדיונים ויציעים"
                />

                <CardFeature
                    iconName="tabler:pig-money"
                    title="סוגי עמלות לבחירתך"
                    subTitle="דמי טיפול (כתוספת למחיר הכרטיס) או עמלה הכלולה במחיר הכרטיס"
                />

                <CardFeature
                    iconName="f7:tickets"
                    title="כרטיסים"
                    subTitle="יצירת כרטיסים שיופיעו בדפי האירוע עם קנייה מאובטחת"
                />

                <CardFeature
                    iconName="icon-park-solid:peoples-two"
                    title="הפקות"
                    subTitle="יצירת סוגי כרטיסים (הנחות , קופונים, חינמים) לרכישה מאובטחת בדפי האירוע"
                />

                <CardFeature
                    iconName="fluent:document-one-page-sparkle-24-regular"
                    title="דף נחיתה עבור כל הפקה"
                    subTitle="דף נחיתה עם כל האירועים הציבוריים הקרובים של ההפקה (ללא הגבלת הפקות וללא הגבלת אירועים)"
                />

                <CardFeature
                    iconName="tdesign:app"
                    title="אפליקציה"
                    subTitle="לסריקת הכרטיסים עבור אייפון ואנדרואיד"
                />

                <CardFeature
                    iconName="mdi:users-add"
                    title="ניהול קהילה"
                    subTitle="לפי אירוע כולל הערות אישיות ויצירת white list לאישור כרטיסים אוטומטי"
                />

                <CardFeature
                    iconName="ph:question"
                    title="שאלות מקדימות (לפני רכישה)"
                    subTitle="נימי מאפשרת להכניס שאלות מקדימות כגון הגבלת גיל או כל שאלה לבחירתכם לפני רכישת כרטיסים"
                />

                <CardFeature
                    iconName="mdi:approve"
                    title="אישור הזמנות"
                    subTitle="אישור אוטומטי או ידני עבור כל כרטיס כולל יכולת לסגמנט לקוחות vip לאישור אוטומטי של ההזמנה"
                />

                <CardFeature
                    iconName="dashicons:admin-links"
                    title="ניהול יחצנים"
                    subTitle="יצירת לינקים שונים עבור כל יחצן עם מידע על רווחיות וכמות כניסות/רכישות עבור כל לינק"
                />

                <CardFeature
                    iconName="carbon:analytics"
                    title="אנליטיקה"
                    subTitle="כל המידע נגיש וזמין עבורכם אודות ממוצע גילאיים, מגדר, יחסי המרה של רכישות ועוד"
                />

                <CardFeature
                    iconName="streamline:send-email"
                    title="אי מיילים ומסרונים ממותגים"
                    subTitle="נשלחים אוטומטית בעת זיכויים, אישורי הזמנות וכל מידע שתרצו לספק לרוכשים שלכם"
                />

                <CardFeature
                    iconName="material-symbols:campaign"
                    title="יצירת קמפיין שיווקי"
                    subTitle="מסרונים (sms), אינסטגרם ופייסבוק למכירת כרטיסים"
                />

                <CardFeature
                    iconName="mdi:human-queue"
                    title="מערכת תורים חכמה"
                    subTitle="תמיכה באירועים של עשרות אלפי משתתפים אשר רוכשים בעת ובעונה אחת"
                />

                <CardFeature
                    iconName="medical-icon:i-waiting-area"
                    title="רשימות המתנה"
                    subTitle="אל תאבדו אף רוכש - עוברים ישירות לרשימות המתנה חכמות ומנוהלות אוטמטית"
                />

                <CardFeature
                    iconName="tabler:vip"
                    title=" בקרת כניסות"
                    subTitle="דרך אפליקציה או צמיד הלקוח יכול להיכנס לאזורים מסוימים באירוע"
                />

                <CardFeature
                    iconName="mdi:cash-off"
                    title="cashless"
                    subTitle="תשלום באפליקציה או ע״י צמיד ללא אשראי או מזומן.
        הצמיד מוטען דרך האפליקציה או מכשיר יעודי (top up)"
                />

                <CardFeature
                    iconName="hugeicons:loyalty-card"
                    title="מועדון לקוחות"
                    subTitle="יצירת מועדון לקוחות פרטי או שוברים ממועדוני לקוחות פופולרים כגון חבר"
                />

                <CardFeature
                    iconName="streamline:subscription-cashflow-solid"
                    title="תמיכה במנויים"
                    subTitle="יצירת כל סוגי המנויים (כולל תשלום מתחדש אוטומטי)
        אין צורך לחדש מנוי באופן ידני כל שנה או חודש"
                />
            </Grid>
            <BookDemo />

            {/* 

            <Stack sx={{ alignItems: "center", mt: 10, width: "100%" }}>

            </Stack> */}

            <Footer />
        </Stack >
    )
}
